const list = "_b7nl1e9ngkz";
const button = "_b7nbrys71";
const bullet = "_b7nb19ps1tt";

export { bullet, button, list };
import "./Bullets.style.linaria.module.css";
//# sourceMappingURL=Bullets.style.js.map
